import { Card, List, Table, Text, Title } from '@mantine/core';
import { describeInvoiceChanges } from '../../helpers/invoiceDisplay';

const InvoiceChangeLog = ({ changes }) => (
  <Card withBorder mt="md">
    <Card.Section inheritPadding py="sm">
      <Title order={4} mb="sm">
        Change log
      </Title>
      {changes.length === 0 ? (
        <Text size="sm" c="dimmed">
          No changes recorded yet.
        </Text>
      ) : (
        <Table withTableBorder>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>When</Table.Th>
              <Table.Th>Who</Table.Th>
              <Table.Th>What changed</Table.Th>
              <Table.Th>Why</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {changes.map((entry) => (
              <Table.Tr key={entry.id}>
                <Table.Td>{new Date(entry.createdAt).toLocaleString()}</Table.Td>
                <Table.Td>
                  {entry.user ? (
                    <>
                      <Text size="sm">
                        {entry.user.firstName} {entry.user.lastName}
                      </Text>
                      <Text size="xs" c="dimmed">
                        {entry.user.email}
                      </Text>
                    </>
                  ) : (
                    <Text size="sm" c="dimmed">
                      Deleted user
                    </Text>
                  )}
                </Table.Td>
                <Table.Td>
                  <List size="sm">
                    {describeInvoiceChanges(entry.changes).map((line) => (
                      <List.Item key={line}>{line}</List.Item>
                    ))}
                  </List>
                </Table.Td>
                <Table.Td>{entry.reason || '—'}</Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      )}
    </Card.Section>
  </Card>
);

export default InvoiceChangeLog;
